<template>
  <div>
    <div class="artical">
      <img class="artical_img" src="../images/logo.png" >
      <div class="artical_cont">“命运”包括两个含义，一是命，即由命主的八字所组成的一定的排列组合，由它所反映的吉或凶，福或祸。二是运，即人一生所走过的每个阶段。“命”和“运”的组合构成了千姿百态的人生“命运”。</div>
    </div>
    <div class="pay">
      <div class="pay_title">您的赞赏，是对我创作的最大鼓励</div>
      <div class="pay_money">
        <button class="price_btn" @click.stop="selectPriceHandler(1, $event)"><span class="price">1</span><span class="unit">元</span></button>
        <button class="price_btn active" @click.stop="selectPriceHandler(6, $event)"><span class="price">6</span><span class="unit">元</span></button>
        <button class="price_btn" @click.stop="selectPriceHandler(8, $event)"><span class="price">8</span><span class="unit">元</span></button>
      </div>
      <div class="pay_money">
        <button class="price_btn" @click.stop="selectPriceHandler(66, $event)"><span class="price">66</span><span class="unit">元</span></button>
        <button class="price_btn" @click.stop="selectPriceHandler(88, $event)"><span class="price">88</span><span class="unit">元</span></button>
        <button class="price_btn" @click.stop="selectPriceHandler(188, $event)"><span class="price">188</span><span class="unit">元</span></button>
      </div>
      <div class="other_btn" v-show="false">
        <a class="btn" href="javascript:void(0)" @click="openPop('moneyBoxPop')">其它金额</a>
      </div>
      <div class="pay_btn">
        <button class="btn" @click="openPop('payWayPop')">赞赏</button>
      </div>

      <!-- 输入金额弹窗 -->
      <pop :isPop="moneyBoxPop">
        <div class="other_money">
          <div class="title">赞赏金额</div>
          <div class="input_box">
            <span class="tip">金额</span>
            <input type="text" placeholder="请输入1-999元" v-model="price">
          </div>
          <div class="pay_btn">
            <button class="btn" @click="openPop('payWayPop')">赞赏</button>
          </div>
        </div>
        <div class="close_btn" @click="closePop"></div>
      </pop>

      <!-- 支付方式弹窗 -->
      <pop :isPop="payWayPop">
        <div class="pay_way">
          <div class="title">支付方式</div>
          <div class="pay_cont">

            <!-- 微信支付 -->
            <div class="pay_item">
              <input type="radio" name="payway" id="wechat" value="wx" v-model="payChannel" checked />
              <label class="filling_wrap" for="wechat">
                <!-- <span class="filling"></span> -->
              </label>
              <img class="icon_wechat" src="../images/icon_wechat.png" />
              <span class="way">微信支付</span>
              <span class="tip">推荐微信用户使用</span>
            </div>

            <!-- 支付宝支付 -->
            <div class="pay_item">
              <input type="radio" name="payway" id="alipay" value="alipay" v-model="payChannel" />
              <label class="filling_wrap" for="alipay">
                <!-- <span class="filling"></span> -->
              </label>
              <img class="icon_wechat" src="../images/icon_alipay.png" />
              <span class="way">支付宝支付</span>
              <span class="tip">支付方便快捷</span>
            </div>

          </div>

          <div class="pay_submit">
            <button class="btn" @click="pay">{{price}}元</button>
          </div>
        </div>
          <div class="close_btn" @click="closePop"></div>
      </pop>

    </div>
  </div>
</template>
<script>
    import 'whatwg-fetch'
    import fetchJsonp from 'fetch-jsonp'
    import getQueryString from '../utils/get.query.js'
    import paramSerializer from '../utils/param.serializer.js'
    import { browser } from '../utils/browser.js'
    import pop from '../components/pop.vue'
    export default {
        name: 'youping',
        components: { pop },
        data() {
            return {
              moneyBoxPop: false,
              payWayPop: false,
              price: 6,  // 商品价格
              priceList: [1, 6, 8, 66, 88, 188],
              payChannel: 'wx',  // 支付渠道
              itemid: '', // 商品id
              itemidList: {
                test: [1298, 1300, 1302, 1304, 1306, 1308],
                online: [2907, 2909, 2915, 2917, 2911, 2913]
              }
            }
        },
        methods: {
            random: function(start, end) {
              return Math.floor(Math.random() * (end - start) + start);
            },

            isWechat: function() {
              let ua = navigator.userAgent;
              return /MicroMessenger/i.test(ua);
            },

            /**
             * 重新定义fetch
             * @param {String}  url  fetch url
             * @param {Function}  callback  fetch callback
             * @return void
             */
            fetch: function(url, config, callback) {
              fetch(url, config)
              .then(res => res.json())
              .then(json => {
                console.log(json)
                callback(json)
              })
              .catch(err => { throw err; })
            },

            /**
             * 重新定义fetchJsonp
             * @param {String}  url  fetch url
             * @param {Function}  callback  fetch callback
             * @param {Boolean}  isRefresh  是否刷新
             * @return void
             */
            fetchJsonp: function(url, callback, isRefresh) {
              fetchJsonp(url)
              .then(res => res.json())
              .then(json => {
                callback(json, isRefresh);
              })
              .catch(err => { throw err; })
            },

            openPop: function(type) {
              document.documentElement.style.overflow = 'hidden';
              document.body.style.overflow = 'hidden';
              this[type] = true;
            },

            closePop: function() {
              document.documentElement.style.overflow = 'auto';
              document.body.style.overflow = 'auto';
              this.moneyBoxPop = false;
              this.payWayPop = false;
            },

            // 选择价格
            selectPriceHandler: function(price, event) {
              this.price = price;
              let btnArr = document.getElementsByClassName('price_btn');
              btnArr = [].slice.call(btnArr);
              btnArr.forEach(function(item) {
                item.className = 'price_btn';
              })
              event.currentTarget.className = 'price_btn active';
            },

            // 支付
            pay: function() {
              let isTest = /test|localhost/.test(location.hostname);

              let channel_mark = getQueryString('channel') || 'shengxiao';

              if (isTest) {
                this.itemid = this.itemidList.test[this.priceList.indexOf(this.price)];
              } else {
                this.itemid = this.itemidList.online[this.priceList.indexOf(this.price)];
              }

              let url;
              if (isTest) {
                url = 'http://test.shop.linghit.com/index.php?s=shop&c=pcorder&a=appreciate';
                // url = '/index.php?s=shop&c=pcorder&a=appreciate';
              } else {
                // url = 'http://test.shop.linghit.com/index.php?s=shop&c=pcorder&a=appreciate';
                url = '/index.php?s=shop&c=pcorder&a=appreciate';
              }

              if (this.isWechat()) {
                this.payChannel = 'wechat';
              }

              let postConfig = {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  body: 'goods[0][itemid]=' + this.itemid + '&pay=' + this.payChannel + '&channel_mark=' + channel_mark + '&channel=zanshang' + '&goods[0][num]=1'
              };

              // fetch(url, postConfig, this.payCallBack);
              fetch(url, postConfig)
              .then(res => res.json())
              .then(json => {
                console.log(json)
                // callback(json)
                if (json.status) {
                  window.location.href = json.url;
                } else {
                  mmcWapShopPayByNativeSDK({
                      order_id: json.order_id,
                      subject: json.subject,
                      price: json.price,
                      notify_url: json.notify_url,
                      return_url: json.return_url
                  });
                }
              })
              .catch(err => { throw err; })
            },

            // 支付成功回调
            payCallBack: function(json) {
              console.log('支付返回结果', json);
              if (json) {
                // window.location.href = json.url;
                mmcWapShopPayByNativeSDK({
                    order_id: json.order_id,
                    subject: json.subject,
                    price: json.price,
                    notify_url: json.notify_url,
                    return_url: json.return_url
                });
              }
            }

        },
        mounted() {

        },
        beforeDestroy() {

        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// pay.vue?1fe37e64